import RegionsForm from 'src/components/dahsboard_regions/form/regions_form';
import { FilesProvider } from 'src/context/files.jsx';
import { OrganizationsProvider } from 'src/context/organization';
import { RegionsProvider } from 'src/context/regions';
import { SpeciesProvider } from 'src/context/species';
import { TakeActionsProvider } from 'src/context/take_action';

const Page = () => (
	<FilesProvider>
		<OrganizationsProvider>
			<TakeActionsProvider>
				<SpeciesProvider>
					<RegionsProvider>
						<RegionsForm />
					</RegionsProvider>
				</SpeciesProvider>
			</TakeActionsProvider>
		</OrganizationsProvider>
	</FilesProvider>
);

export default Page;
